<template>
  <div data-v-e5781868="" class="about-us mainContent top50">
    <div class="banner">
      <div class="section section1">
        <h1>{{$store.state.appInfo.title}}优势</h1>
        <div class="list">
          <div class="item">
            <h2>单日提款</h2>
            高达2,000万
            <div class="line"></div>
          </div>
          <div class="item">
            <h2>随时洗码</h2>
            高达1.1%
            <div class="line"></div>
          </div>
          <div class="item">
            <h2>单笔下注</h2>
            最高200万
            <div class="line"></div>
          </div>
          <div class="item">
            <h2>支持数字币</h2>
            USDT存取便捷
            <div class="line"></div>
          </div>
          <div class="item">
            <h2>实地赌场取款</h2>
            支持澳门、菲律宾出款
          </div>
        </div>
      </div>
    </div>
    <div class="navigation">
      <ul style="display: flex">
        <li class="active"><a> 关于我们 </a></li>
        <li class=""><a> 常见问题 </a></li>
        <li class=""><a> 免责说明 </a></li>
        <li class=""><a> 博彩责任 </a></li>
        <li class=""><a> 联系我们 </a></li>
        <li class=""><a> 隐私政策 </a></li>
        <li class=""><a> 代理加盟 </a></li>
        
        <li class=""><a> 技术支援 </a></li>
      </ul>
    </div>
    <div class="right">
      <!--公司简介-->
      <div data-v-f4b8eb3c="" class="tabcon faq" v-if="false">
        <div data-v-f4b8eb3c="" class="section section2">
          <h1 data-v-f4b8eb3c="">博彩行业风向标</h1>
          <p data-v-f4b8eb3c="">我们为您提供丰富的游戏项目：真人百家乐、上百款火爆电子游戏、超高水位体育投注、彩票、棋牌等任君挑选。</p>
          <div data-v-f4b8eb3c="" class="gameList" >
            <div data-v-f4b8eb3c="" class="item" >
              <img data-v-f4b8eb3c="" data-src="/static/image/01.7bac6344.png" src="/static/image/01.7bac6344.png" lazy="loaded" />
              <div data-v-f4b8eb3c="" class="info">
                <p data-v-f4b8eb3c=""></p>
                <a data-v-f4b8eb3c="" href="javascript:void(0);" class="btn buttonBordered"
                  ><span data-v-f4b8eb3c=""
                    >立即游戏<svg data-v-338e1447="" data-v-f4b8eb3c="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
                ></a>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item">
              <img data-v-f4b8eb3c="" data-src="/static/image/02.3e65b958.png" src="/static/image/02.3e65b958.png" lazy="loaded" />
              <div data-v-f4b8eb3c="" class="info">
                <p data-v-f4b8eb3c=""></p>
                <a data-v-f4b8eb3c="" href="javascript:void(0);" class="btn buttonBordered"
                  ><span data-v-f4b8eb3c=""
                    >立即游戏<svg data-v-338e1447="" data-v-f4b8eb3c="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
                ></a>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item" v-if="false">
              <img data-v-f4b8eb3c="" data-src="/static/image/03.98a38959.png" src="/static/image/03.98a38959.png" lazy="loaded" />
              <div data-v-f4b8eb3c="" class="info">
                <p data-v-f4b8eb3c=""></p>
                <a data-v-f4b8eb3c="" href="javascript:void(0);" class="btn buttonBordered"
                  ><span data-v-f4b8eb3c=""
                    >立即游戏<svg data-v-338e1447="" data-v-f4b8eb3c="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
                ></a>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item">
              <img data-v-f4b8eb3c="" data-src="/static/image/04.b31eb059.png" src="/static/image/04.b31eb059.png" lazy="loaded" />
              <div data-v-f4b8eb3c="" class="info">
                <p data-v-f4b8eb3c=""></p>
                <a data-v-f4b8eb3c="" href="javascript:void(0);" class="btn buttonBordered"
                  ><span data-v-f4b8eb3c=""
                    >立即游戏<svg data-v-338e1447="" data-v-f4b8eb3c="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
                ></a>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item">
              <img data-v-f4b8eb3c="" data-src="/static/image/05.f92dc574.png" src="/static/image/05.f92dc574.png" lazy="loaded" />
              <div data-v-f4b8eb3c="" class="info">
                <p data-v-f4b8eb3c=""></p>
                <a data-v-f4b8eb3c="" href="javascript:void(0);" class="btn buttonBordered"
                  ><span data-v-f4b8eb3c=""
                    >立即游戏<svg data-v-338e1447="" data-v-f4b8eb3c="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
                ></a>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item">
              <img data-v-f4b8eb3c="" data-src="/static/image/06.f4a25b52.png" src="/static/image/06.f4a25b52.png" lazy="loaded" />
              <div data-v-f4b8eb3c="" class="info">
                <p data-v-f4b8eb3c=""></p>
                <a data-v-f4b8eb3c="" href="javascript:void(0);" class="btn buttonBordered"
                  ><span data-v-f4b8eb3c=""
                    >立即游戏<svg data-v-338e1447="" data-v-f4b8eb3c="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
                ></a>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="clear"></div>
          </div>
        </div>
        <div data-v-f4b8eb3c="" class="section section5">
          <h1 data-v-f4b8eb3c="">VIP俱乐部</h1>
          <p data-v-f4b8eb3c="">每月8/18/28爽领分红，畅享贷款0利息，还有更多尊享特权享不停</p>
          <div data-v-f4b8eb3c="" class="item-container">
            <div data-v-f4b8eb3c="" class="item">
              <div data-v-f4b8eb3c=""><img data-v-f4b8eb3c="" src="/static/image/red-envelop.48c995aa.png" /></div>
              <div data-v-f4b8eb3c="" class="txt">
                <span data-v-f4b8eb3c="">股东红包</span>
                <p data-v-f4b8eb3c="">晋级领红包, 最高可领42,800USDT</p>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item">
              <div data-v-f4b8eb3c=""><img data-v-f4b8eb3c="" src="/static/image/stock-dividends.c6325f64.png" /></div>
              <div data-v-f4b8eb3c="" class="txt">
                <span data-v-f4b8eb3c="">股票分红</span>
                <p data-v-f4b8eb3c="">逢8领分红，最高可领28,500股</p>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item">
              <div data-v-f4b8eb3c=""><img data-v-f4b8eb3c="" src="/static/image/intrest-free-loan.b4b4c9ae.png" /></div>
              <div data-v-f4b8eb3c="" class="txt">
                <span data-v-f4b8eb3c="">免息贷款</span>
                <p data-v-f4b8eb3c="">0利息额度高，最高享140,000USDT</p>
              </div>
            </div>
          </div>
          <div data-v-f4b8eb3c="" class="margin20"></div>
          <div data-v-f4b8eb3c="" class="item-container">
            <div data-v-f4b8eb3c="" class="item">
              <div data-v-f4b8eb3c=""><img data-v-f4b8eb3c="" src="/static/image/manager.92c0d060.png" /></div>
              <div data-v-f4b8eb3c="" class="txt">
                <span data-v-f4b8eb3c="">专属经理</span>
                <p data-v-f4b8eb3c="">一对一专人服务，迅速解决所有问题</p>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item">
              <div data-v-f4b8eb3c=""><img data-v-f4b8eb3c="" src="/static/image/domain.ef0093a9.png" /></div>
              <div data-v-f4b8eb3c="" class="txt">
                <span data-v-f4b8eb3c="">专属域名</span>
                <p data-v-f4b8eb3c="">专享顺畅的游戏环境</p>
              </div>
            </div>
            <div data-v-f4b8eb3c="" class="item">
              <div data-v-f4b8eb3c=""><img data-v-f4b8eb3c="" src="/static/image/passway.4557a2a9.png" /></div>
              <div data-v-f4b8eb3c="" class="txt">
                <span data-v-f4b8eb3c="">专属存取通道</span>
                <p data-v-f4b8eb3c="">专属通道不用等，权益特权抢先行</p>
              </div>
            </div>
          </div>
          <a data-v-f4b8eb3c="" class="btn buttonSolid"
            ><span data-v-f4b8eb3c=""
              >查看更多<svg data-v-338e1447="" data-v-f4b8eb3c="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
          ></a>
        </div>
        <div data-v-f4b8eb3c="" class="section section4">
          <h1 data-v-f4b8eb3c="">{{$store.state.appInfo.title}}现场 菲比寻常</h1>
          <p data-v-f4b8eb3c="">豪华游艇PARTY、与性感荷官亲密接触</p>
          <a data-v-f4b8eb3c="" class="btn buttonSolid"
            ><span data-v-f4b8eb3c=""
              >马上参观<svg data-v-338e1447="" data-v-f4b8eb3c="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
          ></a>
        </div>
        <div data-v-f4b8eb3c="" class="section brandway">
          <div data-v-f4b8eb3c="" class="top">
            <h1 data-v-f4b8eb3c="">品牌发展历程</h1>
          </div>
          <div data-v-03c2c755="" data-v-f4b8eb3c="" class="k8BrandWay">
            <div data-v-03c2c755="" class="content"></div>
            <div data-v-03c2c755="" class="c">
              <div data-v-03c2c755="" class="content">
                <div data-v-03c2c755="" class="timeline">
                  <a data-v-03c2c755="" slot="button-prev" class="tool prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"
                    ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon iconPrev">
                      <use data-v-338e1447="" xlink:href="#icon-iconPrev"></use></svg
                  ></a>
                  <div data-v-03c2c755="" class="swiper-container swiper swiper-container-initialized swiper-container-horizontal">
                    <div class="swiper-wrapper" style="transform: translate3d(-2340px, 0px, 0px); transition-duration: 1000ms">
                      <div data-v-03c2c755="" class="swiper-slide swiper-slide-active" style="width: 1180px">
                        <div data-v-03c2c755="" class="swiper-content">
                          <div data-v-03c2c755="" class="line">
                            <div data-v-03c2c755="" class="activeState" style="width: 6.14%"></div>
                          </div>
                          <div data-v-03c2c755="" class="items">
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2021</h3>
                                <p data-v-03c2c755="">09月16日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">07月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2020</h3>
                                <p data-v-03c2c755="">02月09日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">02月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">01月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">01月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">01月01日</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide swiper-slide-next" style="width: 1180px">
                        <div data-v-03c2c755="" class="swiper-content">
                          <div data-v-03c2c755="" class="line">
                            <div data-v-03c2c755="" class="activeState" style="width: 6.14%"></div>
                          </div>
                          <div data-v-03c2c755="" class="items">
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">01月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2019</h3>
                                <p data-v-03c2c755="">11月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">10月02日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">10月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">08月02日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">08月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">06月01日</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1180px">
                        <div data-v-03c2c755="" class="swiper-content">
                          <div data-v-03c2c755="" class="line">
                            <div data-v-03c2c755="" class="activeState" style="width: 6.14%"></div>
                          </div>
                          <div data-v-03c2c755="" class="items">
                            <div data-v-03c2c755="" class="item active">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">02月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2018</h3>
                                <p data-v-03c2c755="">10月02日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">10月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">08月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">03月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">01月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2017</h3>
                                <p data-v-03c2c755="">12月01日</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1180px">
                        <div data-v-03c2c755="" class="swiper-content">
                          <div data-v-03c2c755="" class="line">
                            <div data-v-03c2c755="" class="activeState" style="width: 6.14%"></div>
                          </div>
                          <div data-v-03c2c755="" class="items">
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">11月02日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">11月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">09月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">06月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">05月02日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">05月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">03月01日</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1180px">
                        <div data-v-03c2c755="" class="swiper-content">
                          <div data-v-03c2c755="" class="line">
                            <div data-v-03c2c755="" class="activeState" style="width: 6.14%"></div>
                          </div>
                          <div data-v-03c2c755="" class="items">
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">01月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2016</h3>
                                <p data-v-03c2c755="">12月25日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">08月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">07月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">03月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2015</h3>
                                <p data-v-03c2c755="">12月30日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">04月01日</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1180px">
                        <div data-v-03c2c755="" class="swiper-content">
                          <div data-v-03c2c755="" class="line">
                            <div data-v-03c2c755="" class="activeState" style="width: 6.14%"></div>
                          </div>
                          <div data-v-03c2c755="" class="items">
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">02月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2014</h3>
                                <p data-v-03c2c755="">11月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">04月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">04月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">01月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <h3 data-v-03c2c755="">2013</h3>
                                <p data-v-03c2c755="">11月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">10月01日</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1180px">
                        <div data-v-03c2c755="" class="swiper-content">
                          <div data-v-03c2c755="" class="line">
                            <div data-v-03c2c755="" class="activeState" style="width: 6.14%"></div>
                          </div>
                          <div data-v-03c2c755="" class="items">
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">06月01日</p>
                              </div>
                            </div>
                            <div data-v-03c2c755="" class="item">
                              <div data-v-03c2c755="" class="bullet">
                                <p data-v-03c2c755="">02月01日</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                  </div>
                  <a data-v-03c2c755="" slot="button-next" class="tool next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false"
                    ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon iconNext">
                      <use data-v-338e1447="" xlink:href="#icon-iconNext"></use></svg
                  ></a>
                </div>
                <div data-v-03c2c755="" class="box">
                  <svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon icon iconDoubleQoute1">
                    <use data-v-338e1447="" xlink:href="#icon-iconDoubleQoute1"></use></svg
                  ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon icon iconDoubleQoute2">
                    <use data-v-338e1447="" xlink:href="#icon-iconDoubleQoute2"></use>
                  </svg>
                  <div data-v-03c2c755="" class="swiper-container swiper-img swiper-container-initialized swiper-container-horizontal" style="cursor: grab">
                    <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px); transition-duration: 0ms">
                      <div data-v-03c2c755="" class="swiper-slide swiper-slide-active" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}收购乐橙娱乐</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}正式收购乐橙娱乐，强强联手 携手共赢 实力见证</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-05cfee6191e58a13660c9beb249abffb8.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide swiper-slide-next" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约两位巨星球员</h3>
                            <p data-v-03c2c755="">卢卡斯•波多尔斯基及韦斯利•斯内德正式成为{{$store.state.appInfo.title}}品牌代言人，实力升级，信誉保障</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约意甲卡利亚里足球俱乐部</h3>
                            <p data-v-03c2c755="">卡利亚里足球俱乐部正式成为{{$store.state.appInfo.title}}官方合作伙伴</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-24e9c47e6fc3cfcc507423a2e284c3a26.png_.webp" src="/static/image/banner-brand-24e9c47e6fc3cfcc507423a2e284c3a26.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}收购暴风竞技</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐正式收购暴风竞技，为业界全方位多元化布局打下坚实基础</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3668efe1a12572b15279d2a190e700de9.png_.webp" src="/static/image/banner-brand-3668efe1a12572b15279d2a190e700de9.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">梦想基金助力湖北 为武汉加油</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}梦想基金会捐赠人民币200万给韩红爱心慈善基金会，正能量满满，一起为武汉加油</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-44ada73c49cd997556c3cbb9e643e9b03.png_.webp" src="/static/image/banner-brand-44ada73c49cd997556c3cbb9e643e9b03.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}捐赠物资对抗菲律宾百火山</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐爱心传递 公益先行 为社会救助送暖</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-563eb193a272561a3de9b9836a2685179.png_.webp" src="/static/image/banner-brand-563eb193a272561a3de9b9836a2685179.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">德甲劲旅沙尔克04给您拜年了</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐合作伙伴 德甲劲旅沙尔克04祝您新年快乐 财源广进</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-68f8f87dab2c917c5fc281224afcbb6bb.png_.webp" src="/static/image/banner-brand-68f8f87dab2c917c5fc281224afcbb6bb.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">2019年度传记</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐2019年年度报告，邀您一同见证{{$store.state.appInfo.title}}年度巅峰事迹</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-7c9486d7cbb9ab8f390decd6570e5be26.png_.webp" src="/static/image/banner-brand-7c9486d7cbb9ab8f390decd6570e5be26.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助陈小春巡回演唱会</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐携手龙门联合赞助陈小春STOP ANGRY演唱会</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-8184af4a0586a8970af5e7440fb8d8340.png_.webp" src="/static/image/banner-brand-8184af4a0586a8970af5e7440fb8d8340.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">2019{{$store.state.appInfo.title}}百家乐现场争霸赛</h3>
                            <p data-v-03c2c755="">第二届{{$store.state.appInfo.title}}百家乐大赛赌王誕生 精彩赛事 奖金不断</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-96825df2771c3ab757db0239b0fde19d7.png_.webp" src="/static/image/banner-brand-96825df2771c3ab757db0239b0fde19d7.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐LOGO全新上线</h3>
                            <p data-v-03c2c755="">全新形象升级上线 新LOGO新气象 崭新面貌重新出发</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-10ed97b7186b5eaa3e75284448ccc91a37.png_.webp" src="/static/image/banner-brand-10ed97b7186b5eaa3e75284448ccc91a37.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约菲律宾及马尔代夫国家队</h3>
                            <p data-v-03c2c755="">菲律宾及马尔代夫国家队正式成为{{$store.state.appInfo.title}}娱乐的官方合作伙伴</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-11472c225b9c695377442dafc5ad28647c.png_.webp" src="/static/image/banner-brand-11472c225b9c695377442dafc5ad28647c.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐助力官方合作伙伴沙尔克04</h3>
                            <p data-v-03c2c755="">恭喜沙尔克04足球俱乐部在2019-2020新赛季再创佳绩</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-12f71dc2e001a91668725f24bcca71a819.png_.webp" src="/static/image/banner-brand-12f71dc2e001a91668725f24bcca71a819.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">AG平台首家开设200万限红</h3>
                            <p data-v-03c2c755="">业界首创 提供您至尊体验 豪客首选不容错过</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-133fe81aa347be2294f93e18573a6d1fa6.png_.webp" src="/static/image/banner-brand-133fe81aa347be2294f93e18573a6d1fa6.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">2018年度传记</h3>
                            <p data-v-03c2c755="">邀您回顾{{$store.state.appInfo.title}}娱乐2018精采纪事 我们持续陪伴 为您生活增添更多精采</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-14799bd63b7b53b16c3a5a63b7558b443e.png_.webp" src="/static/image/banner-brand-14799bd63b7b53b16c3a5a63b7558b443e.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐收购悦博体育</h3>
                            <p data-v-03c2c755="">2018行业先锋 携手新老成员一起向前行</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-15a2c1101b60458ee264e03185126e5a24.png_.webp" src="/static/image/banner-brand-15a2c1101b60458ee264e03185126e5a24.png_.webp" lazy="loaded" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐正式推出USDT数字币</h3>
                            <p data-v-03c2c755="">最稳定最保值的货币，资金永不冻结 不受银行监管，安全又方便</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-169bc91c7ec4b0e7d3efeb1e2f3dfa0ab7.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约明星球员Henry（亨利）</h3>
                            <p data-v-03c2c755="">法国史上进球最多的球员-亨利正式成为{{$store.state.appInfo.title}}娱乐品牌代言人</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-179189eb61e2d492048f3d12ff9baa2e3f.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助周杰伦地表最强2世界巡回演唱会</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐冠名赞助，邀请百位会员一同感受周董的现场魅力</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-18065fc6253e8381fc31897cfa92b6c0e0.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">2017年度传记</h3>
                            <p data-v-03c2c755="">邀您回顾{{$store.state.appInfo.title}}娱乐2017精采纪事 携手共同成长 打造更坚实的游戏平台</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-199b38df47a9ae1d94f670e0d6a2ca1f37.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}・梦想基金正式成立</h3>
                            <p data-v-03c2c755="">走心・助梦，{{$store.state.appInfo.title}}娱乐致力于回馈社会，助力体育事业的全方位慈善公益</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-202e19647309672582edfeb529c0cee2fc.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐与曼城合办球迷见面会</h3>
                            <p data-v-03c2c755="">于中国深圳举办球迷见面会，邀请会员现场亲见球员 共度美好的时光</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-21bdd8d0d15a603d2681d8e6cdff960ca6.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">AG{{$store.state.appInfo.title}}之夜</h3>
                            <p data-v-03c2c755="">专为龙门会员定制的私人狂欢派对，顶级俱乐部会员独享HM男人装泳池PARTY</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-22a7b3685790062f6d3e4966df67f5e462.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约卡迪夫城足球俱乐部</h3>
                            <p data-v-03c2c755="">卡迪夫城足球俱乐部正式成为{{$store.state.appInfo.title}}官方合作伙伴</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-23af1aee2c4eae53a8bbf07594f8d9dd54.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约英超曼城德甲沙尔克04</h3>
                            <p data-v-03c2c755="">德甲沙尔克04正式成为{{$store.state.appInfo.title}}官方合作伙伴</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-2464d8dd60a50c93485ed361826f96e0c2.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}手机APP全新上线</h3>
                            <p data-v-03c2c755="">支持安卓、苹果系统，用指尖快速畅游{{$store.state.appInfo.title}}，一次下载 永久享用</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-251edd707c4781d4bddda3b71df745b7dd.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">2017{{$store.state.appInfo.title}}网页改版上线</h3>
                            <p data-v-03c2c755="">全新改版震撼登场，功能更齐全，服务更周到，致力打造最优质的游戏环境</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-266861ac3c5686d9045b8cd25d189ae04d.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助西布朗俱乐部举办足球宝贝大赛</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐赞助足球宝贝大赛，传递青春、美丽、积极及健康的生活方式</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-271f2635f246cfb3930ccbc1b399a91d30.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">2016年度报告</h3>
                            <p data-v-03c2c755="">邀您回顾{{$store.state.appInfo.title}}娱乐2016精采纪事 携手共同成长 打造更坚实的游戏平台</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-289c01977475203ea9abb22434125bb99a.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}冠名罗志祥疯狂世界巡回演唱会</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐赞助罗志祥CRAZY WORLD演唱会香港站，邀请会员现场狂欢</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-29e67f6d66556f9f00168749ab35bb40f0.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">2016{{$store.state.appInfo.title}}娱乐杯 全民健身日・足球慈善赛</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐杯爱满人间 情满人心，援助30名足球特困生进行捐资助学</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-308e86d7e16107402ef24cf5559aed58c8.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助英超西布朗维奇俱乐部</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐宣布成为西布朗维奇足球俱乐部官方主赞助商</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-315bed8c813af3f3fdb82c8214ab591364.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}手机APP全新上线</h3>
                            <p data-v-03c2c755="">一次下载 永久享用，提供给您更快速、便利的游戏环境</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-32b381c0a46efc3fb44c9e5ec06fac57f8.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助陈奕迅2015-16跨年演唱会澳門站</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐赞助陳奕迅跨年演唱会澳门站，與會員一同现场感受歌王的魅力</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-339c6a23c05928eeb15ebe766b278477d6.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助2015美洲杯</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐成为2015唯一在线博彩的美洲杯亚洲区官方赞助商</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3409aca329ff967117e576ae115b26b482.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}续约米夏埃尔•巴拉克</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐与前德国国家队队长续约， 正式成为{{$store.state.appInfo.title}}品牌代言人</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3586a44a3c5870c67fd357b7baf8bba615.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助第三届老甲A</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐荣誉赞助第三届老甲A,带领会员重温经典，完美收官</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-36131fffc6de2c4507a48f6e7bc6a82cb0.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约米夏埃尔•巴拉克</h3>
                            <p data-v-03c2c755="">前德国国家队队长米夏埃尔・巴拉客正式成为{{$store.state.appInfo.title}}娱乐品牌代言人</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-373f331e997858cf24af7e935813a81615.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助昆仑决赛4</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐独家赞助昆仑决4世界格斗冠军赛</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-387c9a0a9b8c38c83439279c7703773e8e.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}举办AV女优荷官周</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐邀您共赴日本东京游，了解不一样的波多野结衣</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3931b126ab92e836e3a27594ecf44c678a.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">赞助60周年澳门格兰披治大赛车兰博基尼</h3>
                            <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐激情赞助 相约澳门一同共襄盛举</p>
                            <a data-v-03c2c755="" class="link">了解详情</a>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-407234d822784320897524ca46fdfed034.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">利博亚洲正式更名为{{$store.state.appInfo.title}}娱乐</h3>
                            <p data-v-03c2c755="">新名称、新气象，全新出发带您迈向更好的未来</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-41cf0664e121329e0fe25509c671357e90.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">行业首创6张牌先发</h3>
                            <p data-v-03c2c755="">首创6张牌先发 业界第一创新先驱</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-42005122a27183b1e97a95a5b70c1014ee.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="swiper-slide" style="width: 1258px">
                        <div data-v-03c2c755="" class="contentWraper">
                          <div data-v-03c2c755="" class="info">
                            <h3 data-v-03c2c755="">行业首家推出包桌百家乐</h3>
                            <p data-v-03c2c755="">首创包桌百家乐 带给您全新的体验</p>
                          </div>
                          <div data-v-03c2c755="" class="promo">
                            <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-43db01244ce029f7e155036a2d0629e1a6.png_.webp" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-v-f4b8eb3c="" class="clear"></div>
      </div>
           <div data-v-f4b8eb3c="" class="tabcon abouthome" >
        <div style="width:12.2rem;margin:0 auto" v-html="dataBox7.content"></div>
      </div>
      <!--常见问题-->
    <div data-v-3ecdc100="" class="tabcon faq" style="display: none">
      <div v-html="dataBox1.content"></div>
      </div>
    <!--免责说明-->
      <div data-v-a1e26770="" class="tabcon responsibleGambling" style="display: none">
        <div data-v-a1e26770="" class="responsible-container" v-html="dataBox8.content">
        
        </div>
        <div data-v-a1e26770="" style="height: 50px"></div>
      </div>
      <!--博彩责任-->
      <div data-v-a1e26770="" class="tabcon responsibleGambling" style="display: none">
        <div data-v-a1e26770="" class="responsible-container" v-html="dataBox8.content">
        
        </div>
        <div data-v-a1e26770="" style="height: 50px"></div>
      </div>
      <!--联系我们-->
      <div data-v-131ba7ff="" class="tabcon contactUs" style="display: none">
        <div data-v-131ba7ff="" class="contactUs-container">
          <div data-v-131ba7ff="" class="t">
            <div data-v-131ba7ff="" class="colorB"></div>
            <h2 data-v-131ba7ff="">联系我们</h2>
          </div>
          <div data-v-131ba7ff="" class="contactUs-content">
            <div data-v-131ba7ff="" class="list">
              <div data-v-131ba7ff="" class="item" @click="$parent.openKefu">
                <div data-v-131ba7ff="" class="left"><img data-v-131ba7ff="" src="/static/image/contect-1.3b922239.png" /></div>
                <div data-v-131ba7ff="" class="right">
                  <h3 data-v-131ba7ff="" class="underline">24小时在线客服</h3>
                  <h4 data-v-131ba7ff="" class="info">
                    <p>我们为您提供24小时线上服务，您可以点击“24小时在线客服”图标与我们联系。</p>
                  </h4>
                </div>
              </div>
              <!-- <div data-v-131ba7ff="" class="item">
                <div data-v-131ba7ff="" class="left"><img data-v-131ba7ff="" src="/static/image/contect-2.746a46cf.png" /></div>
                <div data-v-131ba7ff="" class="right">
                  <h3 data-v-131ba7ff="" class="">客服热线</h3>
                  <h4 data-v-131ba7ff="" class="info">
                    <div class="phonenum">400-1201-721</div>
                  </h4>
                </div>
              </div>
              <div data-v-131ba7ff="" class="item">
                <div data-v-131ba7ff="" class="left"><img data-v-131ba7ff="" src="/static/image/contect-3.15ffe863.png" /></div>
                <div data-v-131ba7ff="" class="right">
                  <h3 data-v-131ba7ff="" class="underline">免费电话</h3>
                  <h4 data-v-131ba7ff="" class="info">
                    <p>请确认您的联系电话，客服人员将会在1分钟内为您回电</p>
                  </h4>
                </div>
              </div>
              <div data-v-131ba7ff="" class="item">
                <div data-v-131ba7ff="" class="left"><img data-v-131ba7ff="" src="/static/image/contect-4.4b1d63ed.png" /></div>
                <div data-v-131ba7ff="" class="right">
                  <h3 data-v-131ba7ff="" class="">电子邮箱</h3>
                  <h4 data-v-131ba7ff="" class="info">
                    <p><a href="###">cs@k8.com</a></p>
                  </h4>
                </div>
              </div> -->
            </div>
            <div v-html="dataBox4.content"> </div>
          </div>
        </div>
      </div>
      <!-- 隐私政策 -->
        <div data-v-3ecdc100="" class="tabcon faq" style="display: none">
      <div v-html="dataBox2.content"></div>
      </div>
            <!-- 代理加盟 -->
        <div data-v-3ecdc100="" class="tabcon faq" style="display: none">
      <div v-html="dataBox5.content"></div>
      </div>
      <!--技术支持-->
      <div data-v-4e3f7088="" class="tabcon technicalSupport" style="display: none">
        <div data-v-4e3f7088="" class="technicalSupport-container">
          <div data-v-4e3f7088="" class="t">
            <div data-v-4e3f7088="" class="colorB"></div>
            <h2 data-v-4e3f7088="">技术支援</h2>
          </div>
          <div data-v-4e3f7088="" class="technicalSupport-content">
            <div data-v-4e3f7088="" class="technicalSupport-banner">
              <h3 data-v-4e3f7088="" class="t1">TeamViewer</h3>
              <h3 data-v-4e3f7088="" class="t2">用心引领行业潮流，领先的不仅仅是技术</h3>
              <a data-v-4e3f7088="" target="_blank" href="https://www.teamviewer.cn/cn/" class="btn buttonBordered"
                ><span data-v-4e3f7088=""
                  >软件下载<svg data-v-338e1447="" data-v-4e3f7088="" aria-hidden="true" class="svg-icon iconArrow">
                    <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></span
              ></a>
            </div>
            <div data-v-4e3f7088="" class="list">
              <div data-v-4e3f7088="" class="item">
                <div data-v-4e3f7088="" class="left"><img data-v-4e3f7088="" src="/static/image/technicalSupport-1.486239ba.svg" /></div>
                <div data-v-4e3f7088="" class="right">
                  <h3 data-v-4e3f7088="" class="">游戏责任</h3>
                  <h4 data-v-4e3f7088="" class="info">网页打不开？游戏进不去？遇到问题不会处理？没关系！{{$store.state.appInfo.title}}娱乐拥有资深的技术团队，24/7为您提供完全解决方案。</h4>
                </div>
              </div>
              <div data-v-4e3f7088="" class="item">
                <div data-v-4e3f7088="" class="left"><img data-v-4e3f7088="" src="/static/image/technicalSupport-2.7d58fc60.svg" /></div>
                <div data-v-4e3f7088="" class="right">
                  <h3 data-v-4e3f7088="" class="">方便快捷</h3>
                  <h4 data-v-4e3f7088="" class="info">您只需要将问题描述给我们，提供连接ID密码，剩下的问题交给我们为您完成。</h4>
                </div>
              </div>
              <div data-v-4e3f7088="" class="item">
                <div data-v-4e3f7088="" class="left"><img data-v-4e3f7088="" src="/static/image/technicalSupport-3.1c072e90.svg" /></div>
                <div data-v-4e3f7088="" class="right">
                  <h3 data-v-4e3f7088="" class="">双重保护</h3>
                  <h4 data-v-4e3f7088="" class="info">除了ID外，TeamViewer还会生成密码，该密码在软件每次启动时都会更改，这提供了安全性保护，防止受到未经许可的访问。</h4>
                </div>
              </div>
              <div data-v-4e3f7088="" class="item">
                <div data-v-4e3f7088="" class="left"><img data-v-4e3f7088="" src="/static/image/technicalSupport-4.45af6670.svg" /></div>
                <div data-v-4e3f7088="" class="right">
                  <h3 data-v-4e3f7088="" class="">安全加密</h3>
                  <h4 data-v-4e3f7088="" class="info">TeamViewer包含丰富的加密，基于RSA私有/公共密钥交换和AES（256）位会话编码。该技术基于与https/SSL相同的标准，被现今标准认为是完全安全的。</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'aboutUS',
  data() {
    return {  dataBox1: {}, dataBox2: {}, dataBox3: {}, dataBox4: {}, dataBox5: {}, dataBox7: {}, dataBox8: {} };
  },
  created() {
    let that = this;
      let arr = [1, 2, 3, 4, 5, 7, 8];
    arr.forEach(el => {
      that.getAllCont(el);
    });
  },
  methods: {
      getAllCont(type) {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/article', { type })
        .then(res => {
          let name = 'dataBox' + type;
          that[name] = res.data;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    //首页banner
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    //首页时间轴品牌历程
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    //盈利榜
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
    //页面tab切换
$('.navigation ul li').click(function() {
	var index=$(this).index();
	$('.tabcon').eq(index).slideDown(300).siblings().slideUp(0);
	$(this).addClass('active').siblings().removeClass('active');
	$('html,body').animate({scrollTop:$('.navigation').offset().top},500);
});

//常见问题展开详情
$('.accordion .group').click(function() {
	$(this).find('.t .arrow').toggleClass('arrow-d');
	$(this).find('.a-row').slideToggle(0);
});
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-6cc178e1.70a3ba40.css';
@import '../../../static/css/chunk-009dfcc3.a4bf2976.css';
@import '../../../static/css/chunk-1225a5b6.b06a16a7.css';
@import '../../../static/css/chunk-639bacf2.80f975ef.css';
@import '../../../static/css/chunk-1bfc786f.3344e98f.css';
@import '../../../static/css/chunk-9c01ee94.ae6edd11.css';
@import '../../../static/css/chunk-4a9bbb2b.cbe5dff6.css';
 .faq .faq-container .row .group .a-row[data-v-3ecdc100] {
          display: none;
        }
</style>



// WEBPACK FOOTER //
// src/components/allMode/aboutUS.vue